export const movies = [
  {
    id: "m1",
    type: "movie",
    title: "孤星遗迹",
    poster:
      "https://readdy.ai/api/search-image?query=A%20lone%20astronaut%20standing%20before%20a%20colossal%20ancient%20alien%20ruin%20on%20a%20desolate%20desert%20planet%2C%20cinematic%20science%20fiction%20movie%20poster%20artwork%2C%20dramatic%20rim%20lighting%2C%20deep%20amber%20and%20teal%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20film%20key%20art&width=400&height=600&seq=movie-poster-01&orientation=portrait",
    year: 2025,
    rating: 8.9,
    genres: ["科幻", "冒险"],
    region: "欧美",
    synopsis:
      "一支深空探索队在废弃星系边缘发现了一座远超人类文明的远古遗迹，随着调查深入，队员们逐渐意识到，遗迹并非沉睡，而是在等待一个迟到万年的访客。",
    director: "亚瑟·诺兰",
    cast: ["李奥·马丁", "索菲亚·陈", "大卫·雷恩"],
    duration: "142分钟",
    views: 1284000,
    tags: ["科幻", "太空", "悬疑", "欧美"],
    featured: true,
    tagline: "当文明的回声响起，人类只是过客",
    heroImage:
      "https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20scene%20of%20a%20colossal%20alien%20ruin%20on%20a%20desert%20planet%20under%20a%20dramatic%20sky%2C%20science%20fiction%20film%20still%2C%20deep%20amber%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20wide%20cinematic%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-hero-01&orientation=landscape",
  },
  {
    id: "m2",
    type: "movie",
    title: "暗夜追凶",
    poster:
      "https://readdy.ai/api/search-image?query=A%20silhouette%20of%20a%20detective%20in%20a%20trench%20coat%20under%20a%20rainy%20city%20street%20lamp%20at%20night%2C%20cinematic%20crime%20thriller%20movie%20poster%20artwork%2C%20moody%20high%20contrast%20lighting%2C%20cold%20blue%20and%20amber%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20film%20key%20art&width=400&height=600&seq=movie-poster-02&orientation=portrait",
    year: 2024,
    rating: 8.4,
    genres: ["悬疑", "犯罪"],
    region: "大陆",
    synopsis:
      "连续三起悬案指向同一个消失多年的名字，一位固执的老刑警在追查真相的过程中，发现自己最信任的搭档也藏着不为人知的秘密。",
    director: "陈默",
    cast: ["张启明", "周雨桐", "王砚"],
    duration: "128分钟",
    views: 962000,
    tags: ["悬疑", "犯罪", "反转", "大陆"],
  },
  {
    id: "m3",
    type: "movie",
    title: "山海秘闻",
    poster:
      "https://readdy.ai/api/search-image?query=A%20mythical%20ancient%20mountain%20range%20with%20floating%20islands%20and%20a%20hidden%20temple%2C%20cinematic%20fantasy%20adventure%20movie%20poster%20artwork%2C%20epic%20golden%20lighting%2C%20rich%20jade%20green%20and%20amber%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20film%20key%20art&width=400&height=600&seq=movie-poster-03&orientation=portrait",
    year: 2025,
    rating: 8.1,
    genres: ["奇幻", "冒险"],
    region: "大陆",
    synopsis:
      "少女偶然翻开一册残缺的上古图卷，被卷入山海异兽与现实交叠的世界，她必须在天光消散之前，找回失落的三片神木叶片。",
    director: "顾青山",
    cast: ["林晚", "江屿", "苏眉"],
    duration: "136分钟",
    views: 845000,
    tags: ["奇幻", "国风", "冒险", "大陆"],
  },
  {
    id: "m4",
    type: "movie",
    title: "都市微光",
    poster:
      "https://readdy.ai/api/search-image?query=A%20young%20couple%20sharing%20an%20umbrella%20on%20a%20glowing%20city%20street%20at%20dusk%2C%20cinematic%20romance%20movie%20poster%20artwork%2C%20soft%20warm%20lighting%2C%20gentle%20amber%20and%20rose%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20film%20key%20art&width=400&height=600&seq=movie-poster-04&orientation=portrait",
    year: 2024,
    rating: 7.8,
    genres: ["爱情", "剧情"],
    region: "大陆",
    synopsis:
      "两个在深夜便利店打工的年轻人，用无数个微小的瞬间，拼凑出一段属于普通人的浪漫。这座城市很大，但他们的世界刚刚好。",
    director: "许南",
    cast: ["安然", "陆一鸣", "何静"],
    duration: "112分钟",
    views: 703000,
    tags: ["爱情", "治愈", "都市", "大陆"],
  },
  {
    id: "m5",
    type: "movie",
    title: "末日黎明",
    poster:
      "https://readdy.ai/api/search-image?query=A%20ruined%20city%20skyline%20with%20a%20massive%20storm%20cloud%20and%20a%20solitary%20figure%20walking%20toward%20the%20light%2C%20cinematic%20disaster%20action%20movie%20poster%20artwork%2C%20dramatic%20backlighting%2C%20ash%20grey%20and%20fiery%20orange%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20film%20key%20art&width=400&height=600&seq=movie-poster-05&orientation=portrait",
    year: 2025,
    rating: 8.6,
    genres: ["灾难", "动作"],
    region: "欧美",
    synopsis:
      "当一场席卷全球的灾变让城市化为废墟，一位普通的救援队长带领幸存者穿越风暴，只为在黎明到来前抵达最后的安全区。",
    director: "马克·海登",
    cast: ["克里斯·沃德", "艾琳·福斯特", "汤姆·贝克"],
    duration: "148分钟",
    views: 1568000,
    tags: ["灾难", "动作", "末日", "欧美"],
    featured: true,
    tagline: "只要还有一线光，人类就不会停下脚步",
    heroImage:
      "https://readdy.ai/api/search-image?query=Epic%20wide%20ruined%20city%20skyline%20with%20a%20massive%20storm%20cloud%20and%20a%20lone%20figure%2C%20disaster%20action%20film%20still%2C%20fiery%20orange%20and%20ash%20grey%20color%20grading%2C%20dramatic%20atmosphere%2C%20wide%20cinematic%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-hero-02&orientation=landscape",
  },
  {
    id: "m6",
    type: "movie",
    title: "笑闹江湖",
    poster:
      "https://readdy.ai/api/search-image?query=A%20playful%20group%20of%20friends%20in%20colorful%20modern%20outfits%20laughing%20together%20indoors%2C%20cinematic%20comedy%20movie%20poster%20artwork%2C%20bright%20cheerful%20lighting%2C%20vivid%20warm%20color%20grading%2C%20minimalist%20centered%20composition%2C%20clean%20neutral%20gradient%20background%2C%20high%20detail%20premium%20film%20key%20art&width=400&height=600&seq=movie-poster-06&orientation=portrait",
    year: 2024,
    rating: 7.5,
    genres: ["喜剧", "家庭"],
    region: "大陆",
    synopsis:
      "三个各怀心思的室友为了凑齐房租，误打误撞开起了一间“万能代办事务所”，从此每天都有意想不到的麻烦找上门。",
    director: "郝乐",
    cast: ["郭小北", "钱多多", "宋佳明"],
    duration: "105分钟",
    views: 612000,
    tags: ["喜剧", "合家欢", "大陆"],
  },
  {
    id: "m7",
    type: "movie",
    title: "雪原猎手",
    poster:
      "https://readdy.ai/api/search-image?query=A%20lone%20hunter%20in%20heavy%20winter%20gear%20tracking%20through%20a%20vast%20snowy%20forest%2C%20cinematic%20action%20movie%20poster%20artwork%2C%20cold%20dramatic%20lighting%2C%20icy%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20film%20key%20art&width=400&height=600&seq=movie-poster-07&orientation=portrait",
    year: 2023,
    rating: 8.2,
    genres: ["动作", "惊悚"],
    region: "欧美",
    synopsis:
      "退役特种兵回到故乡雪原，却发现小镇被一伙走私集团控制。零下三十度的风雪中，一场以寡敌众的复仇悄然展开。",
    director: "伊万·佩特罗夫",
    cast: ["尼可拉·斯通", "安娜·沃尔", "皮特·李"],
    duration: "119分钟",
    views: 588000,
    tags: ["动作", "惊悚", "复仇", "欧美"],
  },
  {
    id: "m8",
    type: "movie",
    title: "归途列车",
    poster:
      "https://readdy.ai/api/search-image?query=A%20traveler%20gazing%20out%20of%20a%20passing%20train%20window%20at%20an%20autumn%20countryside%2C%20cinematic%20drama%20movie%20poster%20artwork%2C%20soft%20golden%20hour%20lighting%2C%20warm%20amber%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20film%20key%20art&width=400&height=600&seq=movie-poster-08&orientation=portrait",
    year: 2023,
    rating: 8.7,
    genres: ["剧情", "家庭"],
    region: "大陆",
    synopsis:
      "一位多年未归的游子踏上一趟漫长列车，途中遇见的每个陌生人，都让他重新想起自己为何离开，又为何想回来。",
    director: "沈知远",
    cast: ["何远山", "林秋", "周宁"],
    duration: "124分钟",
    views: 731000,
    tags: ["剧情", "治愈", "亲情", "大陆"],
  },
  {
    id: "m9",
    type: "movie",
    title: "量子迷城",
    poster:
      "https://readdy.ai/api/search-image?query=A%20futuristic%20neon%20city%20with%20geometric%20quantum%20energy%20structures%20and%20a%20lone%20figure%2C%20cinematic%20science%20fiction%20movie%20poster%20artwork%2C%20glowing%20cyan%20and%20amber%20accent%20lighting%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20film%20key%20art&width=400&height=600&seq=movie-poster-09&orientation=portrait",
    year: 2025,
    rating: 8.3,
    genres: ["科幻", "悬疑"],
    region: "日韩",
    synopsis:
      "在一座由量子计算构建的虚拟都市里，一名记忆调查员发现，所有居民的记忆都来自同一个人的过去。",
    director: "黑泽健",
    cast: ["宫本遥", "佐藤凌", "中村茜"],
    duration: "131分钟",
    views: 690000,
    tags: ["科幻", "悬疑", "烧脑", "日韩"],
  },
  {
    id: "m10",
    type: "movie",
    title: "深海回声",
    poster:
      "https://readdy.ai/api/search-image?query=A%20deep%20sea%20diver%20facing%20a%20giant%20mysterious%20shape%20in%20the%20dark%20ocean%2C%20cinematic%20thriller%20movie%20poster%20artwork%2C%20eerie%20blue%20glow%20lighting%2C%20deep%20ocean%20blue%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20film%20key%20art&width=400&height=600&seq=movie-poster-10&orientation=portrait",
    year: 2024,
    rating: 7.9,
    genres: ["惊悚", "科幻"],
    region: "欧美",
    synopsis:
      "一支深海科考队在马里亚纳海沟深处捕捉到一段无法解释的低频回声，而那声音，似乎正在呼唤他们的名字。",
    director: "劳拉·米勒",
    cast: ["杰克·哈里斯", "米娅·安德森", "卡尔·杨"],
    duration: "113分钟",
    views: 524000,
    tags: ["惊悚", "科幻", "悬疑", "欧美"],
  },
  {
    id: "m11",
    type: "movie",
    title: "时光信箱",
    poster:
      "https://readdy.ai/api/search-image?query=An%20old%20wooden%20mailbox%20in%20a%20sunlit%20meadow%20with%20drifting%20letters%2C%20cinematic%20romance%20movie%20poster%20artwork%2C%20dreamy%20warm%20lighting%2C%20soft%20golden%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20film%20key%20art&width=400&height=600&seq=movie-poster-11&orientation=portrait",
    year: 2023,
    rating: 8.0,
    genres: ["爱情", "奇幻"],
    region: "大陆",
    synopsis:
      "一座废弃的乡村邮筒可以寄信给过去的自己，女孩写下第一封信时，只是想挽回遗憾，却意外改变了许多人的命运。",
    director: "程亦",
    cast: ["夏晴", "顾南风", "叶文"],
    duration: "108分钟",
    views: 486000,
    tags: ["爱情", "奇幻", "治愈", "大陆"],
  },
  {
    id: "m12",
    type: "movie",
    title: "铁血战魂",
    poster:
      "https://readdy.ai/api/search-image?query=A%20soldier%20standing%20amid%20smoke%20and%20ruins%20holding%20a%20flag%20at%20dawn%2C%20cinematic%20war%20movie%20poster%20artwork%2C%20dramatic%20low%20key%20lighting%2C%20dusty%20amber%20and%20grey%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20film%20key%20art&width=400&height=600&seq=movie-poster-12&orientation=portrait",
    year: 2022,
    rating: 8.5,
    genres: ["战争", "剧情"],
    region: "大陆",
    synopsis:
      "一场决定命运的阵地守卫战，一个从未上过战场的年轻士兵，在炮火中明白了什么叫作真正的不退。",
    director: "郑铁",
    cast: ["孙磊", "白鸽", "田锋"],
    duration: "150分钟",
    views: 812000,
    tags: ["战争", "剧情", "热血", "大陆"],
  },
];